import ButtonContainer from "../containers/ButtonContainer";
import cx from "classnames";
import {ArrowLeftIcon, ChevronRightIcon, XCircleIcon, PencilSquareIcon, NoSymbolIcon} from "@heroicons/react/24/outline";
import { faFloppyDisk} from "@fortawesome/free-regular-svg-icons";
import { faCircleNotch, faPaperPlane} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";

export const ButtonArea = ({ children, className }) => (
    <div className={cx("mt-8 mb-6 flex flex-row  items-center sm:!mt-16", className)}>
        {children}
    </div>
);

export const AddButton = (props) => <ButtonContainer {...props} icon="plus-circle" />;

export const BackButton = (props) => (
    <ButtonContainer
        {...props}
        onClick={props.onClick}
        className="
                  inline-flex items-center rounded-md
                  border border-transparent pr-1 text-gray-400
                  focus:outline-none focus:ring-2 focus:ring-gray-300 focus:ring-offset-2
                "
    >
        <ArrowLeftIcon className="mr-2 h-7 w-7" aria-hidden="true" />
        {props.children}
    </ButtonContainer>
);

export const NoWayButton = (props) => (
    <ButtonContainer
        {...props}
        onClick={props.onClick}
        className="inline-flex text-gray-500 items-center justify-self-end rounded-md border border-transparent
    p-1.5 px-3 bg-gray-100 text-base font-medium shadow-sm  first-letter:uppercase focus:outline-none"
    >
        <NoSymbolIcon className="mr-2 h-6 w-6" aria-hidden="true" />
        {props.children}
    </ButtonContainer>
);


export const EditButton = ({className, ...props}) => <ButtonContainer
    {...props}
    onClick={props.onClick}
    className={cx("inline-flex items-center justify-self-end rounded-md border border-transparent ",
        "py-1 p-2 text-sm font-medium shadow-sm  first-letter:uppercase focus:outline-none",
        "bg-orange-600 text-white focus:ring-2 focus:ring-orange-500 focus:ring-offset-2 hover:bg-orange-700", className)}
>
    <PencilSquareIcon className="mr-1 h-7 w-7 p-1" aria-hidden="true" />
    {props.children}
</ButtonContainer>;

export const CancelButton = ({loading, disabled, ...props}) =>  <ButtonContainer
    {...props}
    disabled={disabled}
    className={cx(`inline-flex items-center rounded-md bg-white
                  border border-slate-50 text-gray-600
                  py-1 p-3 text-sm shadow-sm  first-letter:uppercase focus:outline-none
                   focus:ring-2 focus:ring-gray-300 focus:ring-offset-2
                  hover:text-gray-900 hover:border-gray-300
                `,
        {
            "bg-gray-100 text-gray-600 hover:cursor-not-allowed py-2": disabled,
        })}
>
    {loading ? <FontAwesomeIcon icon={faCircleNotch} className={"ml-4 text-xl text-gray-600 mr-1"} spin /> :

        <XCircleIcon className="mr-1 h-7 w-7 text-red-600" aria-hidden="true" />}
    {props.children}
</ButtonContainer>;


export const NextButton = ({ disabled, classname, children, loading, ...props }) => (
    <ButtonContainer
        {...props}
        disabled={disabled}
        className={cx(
            `
            inline-flex items-center justify-self-end rounded-md border border-transparent 
            py-3 pl-10 pr-8 text-base font-medium shadow-sm  first-letter:uppercase focus:outline-none`,
            classname,
            {
                "bg-gray-100 text-gray-600 hover:cursor-not-allowed": disabled,
                "bg-orange-600 text-white hover:bg-orange-700 focus:ring-2 focus:ring-orange-500 focus:ring-offset-2":
                    !disabled,
            }
        )}
    >
        {children}
        {loading ? <FontAwesomeIcon icon={faCircleNotch} className={"ml-4 text-xl text-gray-600"} spin /> :
        <ChevronRightIcon className="ml-2 h-5 w-5" aria-hidden="true" />}
    </ButtonContainer>
);


export const SaveButton = ({ disabled, classname, children, ...props }) => {
    return (
        <ButtonContainer
            {...props}
            className={cx(
                `
               inline-flex items-center justify-self-end
              rounded-md border border-transparent bg-gray-100 py-3 pl-10 
              pr-8 text-base font-medium text-gray-600 shadow-sm first-letter:uppercase focus:outline-none`,
                { "hover:cursor-not-allowed": disabled },
                classname
            )}
        >
            {children}
            <FontAwesomeIcon
                icon={faFloppyDisk}
                className={"ml-4 text-xl text-gray-600"}
                aria-hidden={true}
            />
        </ButtonContainer>
    );
};

export const OrangeButton = ({ disabled, className, children, ...props }) => {
    return (
        <ButtonContainer
            {...props}
            disabled={disabled}
            className={cx(
                `
               inline-flex items-center justify-self-end rounded-md border border-transparent
    py-3 pl-10 pr-8 text-base font-medium shadow-sm  first-letter:uppercase focus:outline-none
    bg-orange-600 text-white focus:ring-2 focus:ring-orange-500 focus:ring-offset-2`,
                {
                    "hover:bg-orange-700": !disabled,
                    "hover:cursor-not-allowed opacity-75 hover:bg-orange-600": disabled,
                },
                className
            )}
        >
            {children}
        </ButtonContainer>
    );
};

export const WhiteButton = ({ disabled, className, children, ...props }) => {
    return (
        <ButtonContainer
            {...props}
            disabled={disabled}
            className={cx(
                `flex w-full items-center justify-center rounded-md border border-gray-300 bg-white py-2 px-2.5 text-sm font-medium text-gray-700 shadow-sm focus:outline-none focus:ring-2 focus:ring-orange-500 focus:ring-offset-2 lg:w-full lg:grow-0`,
                {
                    "hover:bg-gray-50": !disabled,
                    "hover:cursor-not-allowed opacity-75": disabled,
                },
                className
            )}
        >
            {children}
        </ButtonContainer>
    );
};


export const OkButton = ({...props}) => <OrangeButton {...props} icon="check" />;


export const DeleteButton = (props) => <ButtonContainer {...props} icon="trash" />;

export const AlternateDeleteButton = ({ children, loading, ...props }) => (
    <ButtonContainer {...props}>
        { loading ? <FontAwesomeIcon icon={faCircleNotch} className={"text-xl text-white"} spin /> :
        children }
    </ButtonContainer>
);

export const SendButton = ({loading, ...props}) => {
    return <ButtonContainer {...props}>
        {loading ? <FontAwesomeIcon icon={faCircleNotch} spin />:
            <FontAwesomeIcon icon={faPaperPlane}  />}
    </ButtonContainer>
}

export const DownloadButton = (props) => <ButtonContainer {...props} icon="download" />;

export const CloseButton = (props) => <ButtonContainer {...props} icon="times-circle" />;

export const Button = ({disabled, className, ...props}) => <ButtonContainer
    disabled={disabled}
    className={cx(className, { "hover:cursor-not-allowed opacity-75": disabled })}
    {...props}
/>;
